export default {

    init() {

        const ASTA = "asta";
        const CATALOGO = "catalogo";
        const VENDITA_DIRETTA = "vendita_diretta";

        const INPUT_TYPE = "#input-type";

        const INPUT_COMMISSION = "#input-commission";

        function getViewSelectedType() {
            return $(INPUT_TYPE).val();
        }

        function toggleInputCommission(type) {

            switch (type) {
                case ASTA:
                    $(INPUT_COMMISSION).attr('disabled', false);
                    break;
                default:
                    $(INPUT_COMMISSION).attr('disabled', true);
                    break
            }
        }

        $(INPUT_TYPE).change(function (e) {
            toggleInputCommission(getViewSelectedType());
        });

        toggleInputCommission(getViewSelectedType());

    },

    finalize() {

    },
}
